import PageLink from 'components/PageLink/PageLink';
import React from 'react';
import styles from './EditPaymentMethod.module.scss';
import classnames from 'classnames';

interface Props {
  label: string;
  type: string;
  icon?: string;
  buttonUrl: string;
  buttonText: string;
  disabled?: boolean;
}

const PAYMENT_ICONS_PATH = `${process.env.PUBLIC_URL}/images/payment-icons/`;
const MANUAL_PAYMENT_METHOD = 'manual';

const EditPaymentMethod = ({
  label,
  type,
  icon,
  buttonUrl,
  buttonText,
  disabled,
}: Props) => {
  if (!type) {
    return null;
  }

  const paymentMethodIcon = icon
    ? (icon || '').startsWith(MANUAL_PAYMENT_METHOD)
      ? `${PAYMENT_ICONS_PATH}/${MANUAL_PAYMENT_METHOD}.png`
      : `${PAYMENT_ICONS_PATH}/${icon}.png`
    : undefined;

  return (
    <div className={classnames(styles.EditPaymentMethod, "details")}>
      <div className={styles.wrapper}>
        <div className={styles.PaymentMethodContainer}>
        <div className={styles.label}>{label}</div>
        <div className={styles.value}>
          {type}
          {paymentMethodIcon && (
            <img
              src={paymentMethodIcon}
              alt={`${type} icon`}
              className={styles.icon}
            />
          )}
        </div>
        </div>
      </div>
      {buttonUrl && !disabled && (
        <PageLink
          url={buttonUrl}
          text={buttonText}
          className={styles.editBtn}
        />
      )}
    </div>
  );
};

export default EditPaymentMethod;
